var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarnings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.5417C11 15.5857 12.5857 14 14.5417 14H30.125C32.081 14 33.6667 15.5857 33.6667 17.5417V27.4583C33.6667 29.4143 32.081 31 30.125 31H14.5417C12.5857 31 11 29.4143 11 27.4583V17.5417ZM14.5417 16.3611C13.8897 16.3611 13.3611 16.8897 13.3611 17.5417V27.4583C13.3611 28.1103 13.8897 28.6389 14.5417 28.6389H30.125C30.777 28.6389 31.3056 28.1103 31.3056 27.4583V26.2778H18.0833C16.7793 26.2778 15.7222 25.2207 15.7222 23.9167H31.3056V17.5417C31.3056 16.8897 30.777 16.3611 30.125 16.3611H14.5417Z",
    fill: "#6171FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7222 20.1389C15.7222 19.3565 16.3565 18.7222 17.1389 18.7222C17.9213 18.7222 18.5556 19.3565 18.5556 20.1389C18.5556 20.9213 17.9213 21.5556 17.1389 21.5556C16.3565 21.5556 15.7222 20.9213 15.7222 20.1389Z",
    fill: "#6171FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.d6e23415.svg";
export { ForwardRef as ReactComponent };